import { render } from "./visitarBodegas.vue?vue&type=template&id=eec08d4e"
import script from "./visitarBodegas.vue?vue&type=script&lang=js"
export * from "./visitarBodegas.vue?vue&type=script&lang=js"

import "./visitarBodegas.vue?vue&type=style&index=0&id=eec08d4e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__